import React from "react";
import { useI18n } from "../context/I18nContext";

export default function LegalPage({ navigate }) {
  const { t } = useI18n();
  const sections = [
    ["legalPrivacyTitle", "legalPrivacyBody"],
    ["legalDataTitle", "legalDataBody"],
    ["legalAiTitle", "legalAiBody"],
    ["legalAdsTitle", "legalAdsBody"],
    ["legalUserContentTitle", "legalUserContentBody"],
    ["legalThirdPartyRecipeTitle", "legalThirdPartyRecipeBody"],
    ["legalCopyrightTitle", "legalCopyrightBody"],
    ["legalRightsTitle", "legalRightsBody"],
    ["legalDisclaimerTitle", "legalDisclaimerBody"]
  ];

  return (
    <div>
      <button className="btn btn-ghost btn-sm" style={{ marginBottom: 20 }} onClick={() => navigate("profile")}>
        {t("back")}
      </button>
      <div className="page-header">
        <h1>{t("legalTitle")}</h1>
        <p>{t("legalIntro")}</p>
        <span className="legal-updated">{t("legalLastUpdated")}</span>
      </div>

      <section className="legal-grid">
        {sections.map(([titleKey, bodyKey]) => (
          <article className="legal-card" key={titleKey}>
            <h2>{t(titleKey)}</h2>
            <p>{t(bodyKey)}</p>
          </article>
        ))}
      </section>
    </div>
  );
}
